export const consoleCallsStoreKey = 'apiConsoleOptions';
